import React, { useContext } from 'react';
import AppContext from './AppContext';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from './components/Card';
import PokedexRadar from './PokedexRadar';
import { Separator } from './components/Separator';

const createStatLine = (
  stat: number,
  averageStat: number,
  label: string,
) => {
  const difference = stat - averageStat;
  const differenceSymbol = difference > 0 ? '+' : '';
  const differenceComponent = (
    <span className={difference < 0 ? 'text-rose-500' : 'text-green-500'}>
      {` (${differenceSymbol}${difference})` }
    </span>
  );
  return (
    <p>
      <strong>
        {label}
      </strong>
      :&nbsp;
      {stat}
      {difference !== 0 ? differenceComponent : null}
    </p>
  );
};

function PokedexCounter() {
  const {
    dex,
    clickedSpeciesId,
    averageStatsAllSpecies,
  } = useContext(AppContext);
  if (clickedSpeciesId == null) {
    return (
      <div>
        No data.
      </div>
    );
  }

  const { baseStats } = dex[clickedSpeciesId];
  return (
    <Card>
      <CardHeader>
        <CardTitle>Base Stats</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-xs">
          {createStatLine(baseStats.hp, averageStatsAllSpecies.HP, 'HP')}
          {createStatLine(baseStats.atk, averageStatsAllSpecies.Atk, 'Attack')}
          {createStatLine(baseStats.def, averageStatsAllSpecies.Def, 'Defense')}
          {createStatLine(baseStats.spa, averageStatsAllSpecies.SpA, 'Sp. Attack')}
          {createStatLine(baseStats.spd, averageStatsAllSpecies.SpD, 'Sp. Defense')}
          {createStatLine(baseStats.spe, averageStatsAllSpecies.Spe, 'Speed')}
        </div>
        <Separator className="my-6" />
        <PokedexRadar />
      </CardContent>
    </Card>
  );
}

export default PokedexCounter;
